const $ = window.jQuery;
// import bootstrap from "bootstrap";
import "bootstrap";

$(function () {
    //Function to set a cookie
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 13 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get a cookie
    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    
    // Function to check if the modal should be shown
    function shouldShowModal() {
        return !getCookie("welcomeModal");
    }
    
    let greetingModal = $('#landingModal');
    let homePage = $('.page-home');

    if (greetingModal.length && homePage.length && shouldShowModal()) {
        let welcomeModal = new bootstrap.Modal(greetingModal[0]);
        welcomeModal.show();

        // Set cookie when modal is closed
        greetingModal[0].addEventListener('hidden.bs.modal', function () {
            setCookie("welcomeModal", "true", 14); // Cookie expires in 30 days
        });
    }

});
